import React, { Component } from 'react'
export default class Footer extends Component {
    render (){
        return (
            <div>
                <footer className="main-footer">
                    <a href="#">&copy; Notebytes on Demand, All Rights Reserved.</a>
                </footer>
            </div>
        )
    }
}